import {
  EAutoJoinSettingPreference,
  EEmailRecapSettingPreference,
} from "../types/preference";

export const AUTO_JOIN_OPTIONS = [
  { value: EAutoJoinSettingPreference.ALL_MEETINGS },
  { value: EAutoJoinSettingPreference.OWN_MEETINGS },
  { value: EAutoJoinSettingPreference.INVITE_IVAN },
] as const;

export const EMAIL_RECAP_OPTIONS = [
  { value: EEmailRecapSettingPreference.ONLY_ME },
  { value: EEmailRecapSettingPreference.EVERYONE },
] as const;
